/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, HostBinding, ViewEncapsulation } from '@angular/core';
import classNames from 'classnames';
/**
 * Layout 布局
 */
export class Basic {
/**
 * 样式前缀
 */
prefixCls: string;
/**
 * 用户CSS样式
 */
class: string;
/**
 * @return {?}
 */
get classes(): any {
        return classNames(this.prefixCls, this.class);
    }
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 */
constructor(private _renderer: Renderer,
private _elementRef: ElementRef) {

    }

static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'class': [{ type: Input },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function Basic_tsickle_Closure_declarations() {
/** @type {?} */
Basic.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
Basic.prototype.prefixCls;
/**
 * 用户CSS样式
 * @type {?}
 */
Basic.prototype.class;
/** @type {?} */
Basic.prototype._renderer;
/** @type {?} */
Basic.prototype._elementRef;
}

export class Layout extends Basic {
public hasSilder = false;
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(private renderer: Renderer,
private elementRef: ElementRef) {
        super(renderer, elementRef);
        this.prefixCls = 'ant-layout';
    }
/**
 * @return {?}
 */
get classes(): any {
        return classNames({
            [`${this.prefixCls}`]: 1,
            [`${this.prefixCls}-has-sider`]: this.hasSilder
        }, this.class);
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-layout',
    template: '<ng-content></ng-content>',
    styleUrls: ['./style/index.scss'],
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function Layout_tsickle_Closure_declarations() {
/** @type {?} */
Layout.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Layout.ctorParameters;
/** @type {?} */
Layout.propDecorators;
/** @type {?} */
Layout.prototype.hasSilder;
/** @type {?} */
Layout.prototype.renderer;
/** @type {?} */
Layout.prototype.elementRef;
}

export class Header extends Basic {
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(private renderer: Renderer,
private elementRef: ElementRef) {
        super(renderer, elementRef);
        this.prefixCls = 'ant-layout-header';
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-layout-header',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
}

function Header_tsickle_Closure_declarations() {
/** @type {?} */
Header.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Header.ctorParameters;
/** @type {?} */
Header.prototype.renderer;
/** @type {?} */
Header.prototype.elementRef;
}

export class Footer extends Basic {
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(private renderer: Renderer,
private elementRef: ElementRef) {
        super(renderer, elementRef);
        this.prefixCls = 'ant-layout-footer';
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-layout-footer',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
}

function Footer_tsickle_Closure_declarations() {
/** @type {?} */
Footer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Footer.ctorParameters;
/** @type {?} */
Footer.prototype.renderer;
/** @type {?} */
Footer.prototype.elementRef;
}

export class Content extends Basic {
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(private renderer: Renderer,
private elementRef: ElementRef) {
        super(renderer, elementRef);
        this.prefixCls = 'ant-layout-content';
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-layout-content',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
}

function Content_tsickle_Closure_declarations() {
/** @type {?} */
Content.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Content.ctorParameters;
/** @type {?} */
Content.prototype.renderer;
/** @type {?} */
Content.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
